import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { IconButton } from '@hub/button';
import { ChevronLeftMediumIcon } from '@hub/icon';
import { Link } from '@hub/link';
import React from 'react';
import { useHeaderProps } from './header';
import { jsx as _jsx } from "react/jsx-runtime";
export const HeaderBackButton = () => {
  const {
    backLink,
    onClickBack
  } = useHeaderProps();
  if (!backLink && !onClickBack) {
    return null;
  }
  if (backLink) {
    return /*#__PURE__*/_jsx(IconButton, {
      as: props => /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({
        href: backLink,
        ariaLabel: "back"
      }, props), {}, {
        "data-id": "header_header-back-button_HeaderBackButton_Link"
      })),
      variant: "transparent",
      colorScheme: "licorice",
      size: "icon-lg",
      icon: /*#__PURE__*/_jsx(ChevronLeftMediumIcon, {
        boxSize: "size-icon-md",
        "data-id": "header_header-back-button_HeaderBackButton_ChevronLeftMediumIcon"
      }),
      onClick: onClickBack !== null && onClickBack !== void 0 ? onClickBack : () => {},
      "aria-label": "back",
      "data-id": "header_header-back-button_HeaderBackButton_IconButton"
    });
  }
  return /*#__PURE__*/_jsx(IconButton, {
    variant: "transparent",
    colorScheme: "licorice",
    size: "icon-lg",
    icon: /*#__PURE__*/_jsx(ChevronLeftMediumIcon, {
      boxSize: "size-icon-md",
      "data-id": "header_header-back-button_HeaderBackButton_ChevronLeftMediumIcon"
    }),
    onClick: onClickBack !== null && onClickBack !== void 0 ? onClickBack : () => {},
    "aria-label": "back",
    "data-id": "header_header-back-button_HeaderBackButton_IconButton"
  });
};